(function () {
  document.querySelectorAll('[data-carousel-next]').forEach(function (button) {
    var track = document.getElementById(button.getAttribute('data-carousel-next'));
    if (!track) return;
    button.addEventListener('click', function () {
      var cardWidth = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 200;
      track.scrollBy({ left: cardWidth * 2, behavior: 'smooth' });
    });
  });
})();
